import NewSlideshow from '../../classes/NewSlideshow';

export const initSliderWithText = () => {
	const sliders = document.querySelectorAll( 'section.slider-with-text' );

	if ( !sliders.length )
	{
		return;
	}

	sliders.forEach( ( slider ) => {
		const sliderInstance = new NewSlideshow( {
			element: slider
		} );
		
		sliderInstance.init();

		const bookmarks = slider.querySelectorAll( 'ul.bookmarks > li' );

		if ( !bookmarks.length )
		{
			return;
		}

		const updateLineDivWidth = (bookmarks, lineDivs) => {
			lineDivs.forEach( ( line, index ) => {
				lineDivs[index].style.width = `${bookmarks[index + 1]?.offsetLeft - bookmarks[index]?.offsetLeft - bookmarks[index]?.offsetWidth - 4}px`;
			} );
		}

		const lineDivs = [];

		bookmarks.forEach( ( bookmark, index ) => {
			const lineDiv = document.createElement( 'div' );

			bookmark.append( lineDiv );
			lineDivs.push( lineDiv );
			lineDiv.style.width = `${bookmarks[index + 1]?.offsetLeft - bookmarks[index]?.offsetLeft - bookmarks[index]?.offsetWidth - 4}px`;
		} );

		window.addEventListener( 'resize', () => updateLineDivWidth( bookmarks, lineDivs ) );
	} );
}
